import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { createEffect } from '@ngrx/effects';
import { tap, filter } from 'rxjs/operators';

declare var gtag: any;

@Injectable()
export class GoogleAnalyticsEffects {
  pageView = createEffect(
    () => () =>
      this.router.events.pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        tap((event: NavigationEnd) => {
          gtag('config', 'G-CR2ECVK7HN', {
            page_path: event.urlAfterRedirects
          });
        })
      ),
    { dispatch: false }
  );

  constructor(private router: Router) {}
}
